import { render, staticRenderFns } from "./userBusiness.vue?vue&type=template&id=db006f2e&scoped=true"
import script from "./userBusiness.vue?vue&type=script&lang=js"
export * from "./userBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db006f2e",
  null
  
)

export default component.exports